"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _YesNoData = _interopRequireDefault(require("./components/YesNoData"));

var MOBILE_KEY = 'mobileAudit';
var _default = {
  results: [new _YesNoData.default({
    localizedTextKey: 'results.mobile.fontSizes',
    resultKeyPath: [MOBILE_KEY, 'usesLegibleFontSizes']
  }), new _YesNoData.default({
    localizedTextKey: 'results.mobile.touchFriendly',
    resultKeyPath: [MOBILE_KEY, 'areTapTargetsProperlySized']
  }), new _YesNoData.default({
    localizedTextKey: 'results.mobile.responsive',
    resultKeyPath: [MOBILE_KEY, 'isSizedForViewport']
  })]
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/data/MobileData.js
// module id = 144
// module chunks = 0